(function ($) {

  // Scroll menu up on down-scroll
  var scrollCeiling = $(window).scrollTop();
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > scrollCeiling + 100) {
      // If scrolling down, hide nav
      $(".header").addClass("scrolled");
      scrollCeiling = $(window).scrollTop();
    } else if (scrollTop < scrollCeiling) {
      // If scrolling up, show nav
      $(".header").removeClass("scrolled");
      scrollCeiling = $(window).scrollTop();
    }
  });

  // Nav Menu Hover
  $(".header-nav .menu-item-has-children").hover(function () {
    if ($(window).width() > 1024) {
      // When hovering, hide all other submenus
      if (this != $(".header-nav .menu-item-has-children.expanded").get(0)) {
        $(".header-nav .menu-item-has-children.expanded").children(".sub-menu").fadeOut(200);
        $(".header-nav .menu-item-has-children.expanded").removeClass("expanded");
      }
      // Display menu
      $(this).addClass("expanded");
      $(this).children(".sub-menu").fadeIn(200);
    }
  }, function () {
    if ($(window).width() > 1024) {
      // When leaving a hover, wait .3s and check if user is still not hovering, then hide
      setTimeout(() => {
        if (!$(this).is(":hover")) {
          $(this).removeClass("expanded");
          $(this).children(".sub-menu").fadeOut(200);
        }
      }, 300);
    }
  });

  // Nav Menu Hamburger
  $("#header-nav__hamburger").click(function () {
    if ($(this).hasClass("expanded")) {
      $("body").removeClass("locked");
      $(this).removeClass("expanded");
      $("#header__dropdown").fadeOut(200);
    } else {
      $("body").addClass("locked");
      $(this).addClass("expanded");
      $("#header__dropdown").fadeIn(200);
    }
  });

  // Mobile Dropdown Buttons
  $(".header__dropdown .menu-item__arrow").click(function () {
    if ($(this).parent().hasClass("expanded")) {
      $(this).parent().removeClass("expanded");
      $(this).siblings(".sub-menu").slideUp(200);
    } else {
      $(this).parent().addClass("expanded");
      $(this).siblings(".sub-menu").slideDown(200);
    }
  });

  // Subscribe Modal
  $("#subscribe-modal-btn").click(function () {
    $("body").addClass("locked");
    $("#subscribe-modal").fadeIn(200);
  });
  $("#subscribe-modal__close").click(function () {
    $("body").removeClass("locked");
    $("#subscribe-modal").fadeOut(200);
  });

  // Promo Popup
  if ($("body").length && $("#offer-promo-popup").length) {
    // Get the current page's unique identifier (URL path)
    const pageKey = window.location.pathname;

    // Create a unique key for session storage based on the current page
    const promoPopupKey = `promo-popup-${pageKey}`;

    // Check if the popup has been closed for the current session
    if (!sessionStorage.getItem(promoPopupKey)) {
      // Show the popup
      $("#offer-promo-popup").fadeIn(200);
      $("body").addClass("locked");
    }

    // Close the popup when the close button is clicked
    $("#offer-promo-popup__close").click(function () {
      $("#offer-promo-popup").fadeOut(200);
      $("body").removeClass("locked");

      // Set the session storage to indicate the popup has been closed for this page
      sessionStorage.setItem(promoPopupKey, true);
    });
  }


  //single series event items border 

  $(document).ready(function () {
    $('.event-month').each(function () {
      var $eventItems = $(this).find('.event-item');

      if ($eventItems.length === 1) {
        // If there is only one event item, remove all borders
        $eventItems.css({
          'border-top': 'none',
          'border-bottom': 'none'
        });
      } else {
        // If there are multiple event items
        $eventItems.each(function (index) {
          // Remove both top and bottom borders for the first event item
          if (index === 0) {
            $(this).css({
              'border-top': 'none',
              'border-bottom': 'none'
            });
          }
          // Remove border-bottom for the last event item
          else if (index === $eventItems.length - 1) {
            $(this).css('border-bottom', 'none');
          }
          // Add border-top for all other event items
          else {
            $(this).css('border-top', '2px solid #D5D2CD');
          }
        });
      }
    });
  });


})(jQuery);